import { useTranslations } from "next-intl";
import pluralizer from "pluralize";

import { Text, Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";

type TasksUsedProps = {
  isError?: boolean;
  used: number | null;
};

const TasksUsed = ({ isError = false, used }: TasksUsedProps) => {
  const t = useTranslations("history-page.run-row");

  if (isError) {
    return (
      <Tooltip content={t("task-count-error-tooltip")} allowMultiline={true}>
        <TooltipFocusableTrigger>
          <div>
            <Text color="GrayWarm9" tag="div" textAlign="center" type="Body2">
              –
            </Text>
            <Text
              color="GrayWarm9"
              tag="div"
              textAlign="center"
              type="SmallPrint2"
            >
              {t("task-count-error-label")}
            </Text>
          </div>
        </TooltipFocusableTrigger>
      </Tooltip>
    );
  }

  if (used === null) {
    return (
      <Tooltip content={t("task-count-pending-tooltip")} allowMultiline={true}>
        <TooltipFocusableTrigger>
          <div>
            <Text color="GrayWarm9" tag="div" textAlign="center" type="Body2">
              –
            </Text>
            <Text
              color="GrayWarm9"
              tag="div"
              textAlign="center"
              type="SmallPrint2"
            >
              {t("task-count-pending-label")}
            </Text>
          </div>
        </TooltipFocusableTrigger>
      </Tooltip>
    );
  }

  return (
    <div>
      <Text color="GrayWarm9" tag="div" textAlign="center" type="Body2">
        {used}
      </Text>
      <Text color="GrayWarm9" tag="div" textAlign="center" type="SmallPrint2">
        {pluralizer("task", used)}
      </Text>
    </div>
  );
};

export default TasksUsed;
